import React, { useState, useEffect } from "react";
import { Drawer, Box, Typography, IconButton, Checkbox, Tabs, Tab   } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Table } from "react-bootstrap";

// import "./DelegatedAccessModal.css";
// import GetInitiativeStageDetails from "../../hooks/GetInitiativeStageDetails/GetInitiativeStageDetails";
import Tooltip from "@mui/material/Tooltip";
import { PrimaryButton } from "@fluentui/react";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1"; // already used elsewhere
import DelegatedHistorySection from "./DelegatedHistorySection";
import { toast } from "react-toastify";
import { Login } from "@mui/icons-material";

const style = {
  // width: "60%", // Set the drawer width to 60%
  padding: "16px", // Add some padding for better spacing
  overflowY: "auto", // Enable vertical scrolling
};

// refreshKey Added By Madhuri.K on 24-04-2025
const DelegatedAccessModal = ({ open, handleClose, initiativesID, NodID, NodRevID, initiativesData  }) => {
  const [delegateMap, setDelegateMap] = useState({});   // { stageName: {order, resources:[…]} }
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);           // 0 = Details, 1 = History
  const [data, setData] = useState({});
  const [selectedApproverID, setSelectedApproverID] = useState(null);

// figure out the first and last workflow stage orders
const stageOrders = React.useMemo(
  () => Object.values(delegateMap).map(s => s.order),
  [delegateMap]
);
const firstOrder = Math.min(...stageOrders);
const lastOrder  = Math.max(...stageOrders);

// --- helper: TabPanel component for conditional rendering
   function TabPanel({ value, index, children }) {
    return value === index ? <Box>{children}</Box> : null;
  }
  // Extract values safely
// console.log("DelegatedAccessModal1234", initiativesData, NodRevID);

// console.log("DelegatedAccessModal1234", initiativesData, NodRevID);

// const initiativeObj = Array.isArray(initiativesData) ? initiativesData[0] : initiativesData;
const initiativeObj = Array.isArray(initiativesData)
  ? initiativesData.find(item => item.ideaIdPk === initiativesID)  // or use 'id' if that's what you're matching
  : initiativesData;

const initiativeTitle = initiativeObj?.title || "";
const initiativeCode = initiativeObj?.initiativeCode || "";
const processName = initiativeObj?.processName || initiativeObj?.processName || "";
const businessGroup = initiativeObj?.businessGroup || "NA";
const organizationUnit = initiativeObj?.organizationUnit || "NA";

  // grab user id from the session (same pattern used in BasicDetailEdit)
  // const { employeeId: userID } = JSON.parse(sessionStorage.getItem("user") || "{}");
const { employeeId: userID, employeeName: LoginPersonName } = JSON.parse(sessionStorage.getItem("user") || "{}");

  useEffect(() => {
    if (!open) return;                // fetch only when the drawer becomes visible
    const fetchDelegates = async () => {
     
      setLoading(true);
      try {
        const res = await AxiosInstance1.get(
          `/api/InitiativeDelegateApproval/GetInitiativeDelegateResources`,
          { params: { InitiativeID: initiativesID, UserID: userID }}
        );
        setDelegateMap(res.data?.groupedByStage || {});
        setData(res.data?.data[0] || {})
      } catch (err) {
        console.error("Delegate fetch failed", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDelegates();
  }, [open, initiativesID, userID]);

  const handleSave = async () => {
  try {
    // Find the selected approver from the delegateMap
    let selectedApproverID = null;
    
    for (const [stageName, stage] of Object.entries(delegateMap)) {
      const selectedResource = stage.resources?.find(r => r.isChecked === 1);
      if (selectedResource) {
        selectedApproverID = selectedResource.approverID;
        break;
      }
    }
    
    if (!selectedApproverID) {
      toast.error("Please select an approver to delegate to.");
      return;
    }

    const payload = {
      delegateFromID: userID,
      delegateToID: selectedApproverID,
      createdBy: userID,
      natureOfDemandID: NodID || data?.natureofDemandID,
      // initiativeID: initiativeObj?.ideaIdPk || initiativesID || data?.ideaID,
      initiativeID:
        initiativeObj?.ideaIdPk ??
        initiativesID ??
        (data?.ideaID ? parseInt(data.ideaID, 10) : null),
    };

    console.log("Sending payload:", payload);

    const res = await AxiosInstance1.post(
      "/api/InitiativeDelegateApproval/InsertInitiativeDelegateAssign",
      payload
    );

    console.log("API response:", res.data);

    if (res.data?.type === 1) {
  /* ---------- NEW, ROBUST LOGIC ---------- */
  const resultMessage = (res.data?.data?.[0]?.result ?? "").trim();   // remove leading space

  // ①  Match "…already delegated" **or** "…already been delegated", in any case or spacing
  if (/already\s+(been\s+)?delegated/i.test(resultMessage)) {
    toast.error(resultMessage);       // shows: "Selected resource has already been delegated by another user."
    return;                           // stop – don't let success toasts run
  }

  // ②  Success paths
  if (/update/i.test(resultMessage)) {
    toast.success("Delegated updated successfully");
  } else {
    toast.success("Delegated saved successfully");
  }
  handleClose();
  /* --------------------------------------- */
} else {
  toast.error("Save failed: " + (res.data?.message || "Unknown error"));
}

  } catch (error) {
    console.error("Save failed:", error);
    toast.error("An error occurred while saving.");
  }
};

  return (
    <Drawer anchor="right" open={open} onClose={handleClose}>
      <Box sx={{ width: "70vw", padding: 2, position: "relative" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          sx={{ backgroundColor: "#f5f5f5" }}
        >
          <Typography variant="h6">Access For Delegation</Typography>
          <IconButton onClick={handleClose}>
            <Tooltip title="Close">
              {/* <Tooltip title="Close"> */}
                <CloseIcon />
              {/* </Tooltip> */}
            </Tooltip>
          </IconButton>
        </Box>
                {/* Tabs */}
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="Details" sx={{ textTransform: "none" }} />
          <Tab label="History" sx={{ textTransform: "none" }} />
        </Tabs>

        {/* --- DETAILS TAB --- */}
        <TabPanel value={tab} index={0}>
        <Box className="py-0">
          <div className="text-end mb-1">
            <PrimaryButton text="Save" onClick={handleSave}/>
          </div>

          <div className="mb-3">
            <div className="row">
              
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4 text-end" style={{ color: '#5841e8'}}>
                    <strong>Login Person :</strong>
                  </div>

                  <div className="col-md-8 text-start" style={{ color: '#5841e8'}}> 
                    <strong>{LoginPersonName
                          ?.replace(/\./g, " ")
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ") || "NA"}</strong></div>
                </div>
              </div>
              <div className="col-md-6 mt-2"></div>
               <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4 text-end">
                    <strong>Initiative Title :</strong>
                  </div>

                  <div className="col-md-8 text-start"> 
                    {data?.title || "NA"}</div>
                </div>
              </div>
                 <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4 text-end">
                    <strong>Initiative Code :</strong>
                  </div>

                  <div className="col-md-8 text-start">
                     {data?.demandCode || "NA"}</div>
                </div>
              </div>
              <div className="col-md-8 mt-2">
                <div className="row">
                  <div className="col-md-3 text-end">
                    <strong>Nature of Initiative:</strong>
                  </div>

                  <div className="col-md-9 text-start">
                    {data?.natureofDemand || "NA"}
                  </div>
                </div>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4 text-end">
                    <strong>Business Group :</strong>
                  </div>
                  <div className="col-md-8 text-start">
                    {data?.businessGroup || "NA"}</div>
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-4 text-end">
                    <strong>Organization Unit :</strong>
                  </div>
                  <div className="col-md-8 text-start">{data?.location || "NA"}</div>
                </div>
              </div>
            </div>
          </div>
        </Box>

          {/* Table for Workflow Approvers */}
        <Table bordered>
          <thead>
            <tr>
              <th className="col-sm-1">Order</th>
              <th className="col-sm-4">Stages</th>
              <th className="col-sm-3">Resource</th>
              <th className="col-sm-1 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {/* 1 – loading indicator */}
            {loading && (
              <tr>
                <td colSpan={4} className="text-center">Loading…</td>
              </tr>
            )}

            {/* 2 – "no data" message */}
            {!loading &&
              (Object.keys(delegateMap).length === 0 ||
                Object.values(delegateMap).every(s => !s.resources?.length)) && (
                <tr>
                  <td colSpan={4} className="text-center">
                    There are no items to show in this view.
                  </td>
                </tr>
              )}

            {/* 3 – actual data rows */}
            {Object.entries(delegateMap)
              .sort(([, a], [, b]) => a.order - b.order)
              .map(([stageName, stage]) => (
                <React.Fragment key={stage.order}>
                  <tr>
                    <td style={{ background: '#eaeaea' }}>{stage.order}</td>
                    <td colSpan={3} style={{ background: '#eaeaea' }}>{stageName}</td>
                  </tr>

                  {(stage.resources ?? []).map((r, index) => {      // ← note the { here
                    const isFirstStage = stage.order === firstOrder;
                    const isLastStage = stage.order === lastOrder;
                    const isSelf =
                      (LoginPersonName || "").toLowerCase() === (r.resource || "").toLowerCase();
                    const isDisabled = isSelf || isFirstStage || isLastStage;

                    return (
                      <tr key={`${stageName}-${r.approverID}-${index}`}>
                        <td colSpan={2}></td>
                        <td>{r.resource}</td>
                        <td className="text-center">
                          <Checkbox
                            className="p-0"
                            checked={r.isChecked === 1}
                            style={{
                              cursor: isDisabled ? 'not-allowed' : 'pointer',
                              opacity: isDisabled ? 0.5 : 1
                            }}
                            onChange={() => {
                              if (isDisabled) return;           // safety‑net

                              // toggle: if clicked checkbox is already checked, uncheck it; otherwise check it
                              setDelegateMap(prev => {
                                const newMap = { ...prev };

                                // Check if the current checkbox is already checked
                                const currentResource = newMap[stageName].resources.find(res => res.approverID === r.approverID);
                                const isCurrentlyChecked = currentResource?.isChecked === 1;

                                // 1 — zero everything first
                                Object.keys(newMap).forEach(sKey => {
                                  newMap[sKey] = {
                                    ...newMap[sKey],
                                    resources: newMap[sKey].resources.map(res => ({
                                      ...res,
                                      isChecked: 0
                                    }))
                                  };
                                });

                                // 2 — if it wasn't checked before, check it now
                                if (!isCurrentlyChecked) {
                                  newMap[stageName] = {
                                    ...newMap[stageName],
                                    resources: newMap[stageName].resources.map(res =>
                                      res.approverID === r.approverID
                                        ? { ...res, isChecked: 1 }
                                        : res
                                    )
                                  };
                                }

                                return newMap;
                              });
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              ))}
          </tbody>
        </Table>
</TabPanel>

        {/* --- HISTORY TAB --- */}
        <TabPanel value={tab} index={1}>
          <DelegatedHistorySection initiativeID={initiativesID}/>
        </TabPanel>
      </Box>
    </Drawer>
  );
};

export default DelegatedAccessModal;